import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import {rgba} from 'polished';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledBlocker = styled(Box)`
  position: fixed;
  inset: 0;
  z-index: ${props => props.theme.property('zIndex.blocker')};

  background-color: transparent;

  &.Blocker-hole {
    --blocker-hole-pad: ${props => props.theme.layout('0.5sp')};
    --blocker-hole-ring: ${props => props.theme.layout(2)};

    pointer-events: none;
  }

  .Blocker-shade {
    position: absolute;
    inset: 0;
    background-color: ${props => rgba(props.theme.property('palette.common.black'), 0.5)};
    pointer-events: auto;
  }

  .Blocker-ring {
    position: absolute;
    top: calc(var(--blocker-hole-top) - (var(--blocker-hole-pad) + var(--blocker-hole-ring)));
    left: calc(var(--blocker-hole-left) - (var(--blocker-hole-pad) + var(--blocker-hole-ring)));
    width: calc((var(--blocker-hole-right) - var(--blocker-hole-left)) + (2 * (var(--blocker-hole-pad) + var(--blocker-hole-ring))));
    height: calc((var(--blocker-hole-bottom) - var(--blocker-hole-top)) + (2 * (var(--blocker-hole-pad) + var(--blocker-hole-ring))));
    box-sizing: border-box;
    border: var(--blocker-hole-ring) solid ${props => props.theme.property('palette.primary.main')};
    border-radius: calc(var(--blocker-hole-radius) + (var(--blocker-hole-pad) + var(--blocker-hole-ring)));
    background-color: ${props => rgba(props.theme.property('palette.common.white'), 0.2)};
    pointer-events: none;
  }

  &.Blocker-interactive {
    .Blocker-ring {
      background-color: transparent;
    }
  }

  ${ComponentStyles}
`;

StyledBlocker.propTypes = {
  theme: PropTypes.object
};

export default StyledBlocker;
